import { SaveMessageState } from '../../lib/enums/saveMessage';

export const state = {
  currentStep: 0,
  onContinueFunc: null,
  isOverrideContinue: false,
  saveMessageState: SaveMessageState.None
};

export const mutations = {
  setNavigation(
    state: any,
    payload: {
      step: number;
      overrideContinue: boolean;
      onContinueFunc: () => void;
    }
  ): void {
    state.currentStep = payload.step;
    state.onContinueFunc = payload.onContinueFunc;
    state.isOverrideContinue = payload.overrideContinue;
  },
  setSaveMessageState(
    state: any,
    { saveMessageState }: { saveMessageState: SaveMessageState }
  ): void {
    state.saveMessageState = saveMessageState;
  }
};
